import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import FirstContactAttachmentForm, {type FirstContactAttachmentFormProps} from "pages/consumers/firstContactAttachment/components/FirstContactAttachmentForm";
import {modalClose} from "components/modals/genericFunctions";
import SlideOver, {SlideOverProps} from "components/generic/SlideOver";


interface OwnProps extends SlideOverProps, FirstContactAttachmentFormProps {
}

type Props = OwnProps;

// @ts-ignore
const FirstContactAttachmentModal = NiceModal.create<Props>(({createFirstContactAttachment, onClose, header, ...rest}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <FirstContactAttachmentForm  {...rest}/>
        </SlideOver>
    )
})

export default FirstContactAttachmentModal;
